import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

const StyledComponent = styled(({css, ...rest}) => <div {...rest} />)`

  padding: ${p => p.theme.s} ${p => p.theme.m};
  & + & {
   margin-top: ${p => p.mb !== undefined ? p.mb : p.theme.s};
  };
  ${p => p.pb !== undefined && css`
    padding-bottom: ${p => p.pb};
  `};
  ${p => p.css};
`

const _CardInner = (props) => <StyledComponent {...props} />
_CardInner.propTypes = {
  css: PropTypes.string,
  mb: PropTypes.oneOfType(
    [
      PropTypes.string,
      PropTypes.number
    ]
  ),
  pb: PropTypes.oneOfType(
    [
      PropTypes.string,
      PropTypes.number
    ]
  )

}

export default _CardInner

